import { render, staticRenderFns } from "./BaseCarouselIndicators.vue?vue&type=template&id=28d757cf"
import script from "./BaseCarouselIndicators.vue?vue&type=script&lang=js"
export * from "./BaseCarouselIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports